import { Result } from 'antd'
import { useTranslation } from 'react-i18next'
import { ResultStatusType } from 'antd/lib/result'

type InfoPageParams = {
    status: ResultStatusType
    title: string
    subTitle: string
}

const InfoPage = ({ status, title, subTitle }: InfoPageParams) => {
    const { t } = useTranslation()

    return (
        <Result
            status={status}
            title={t(title)}
            subTitle={t(subTitle)}
        />
    )
}

export default InfoPage